import React from "react";
import "../style/RequestModal.css";

const adRequestModal = ({ ad, onClose }) => {

  function checkBoolean(value) {
    return value ? "Si" : "No";
  }

  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = String(date.getFullYear()).slice(-2); // Get last two digits of the year

    return `${day}/${month}/${year}`;
  }
  
  if (!ad) return null;
  const image = ad.imagenes && ad.imagenes.length > 0 ? ad.imagenes[0].replace("http://", "https://") : null;
  return (
    <div className="request-modal-overlay" onClick={onClose}>
      <div className="request-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button-left" onClick={onClose}>X</button>
        <h2>Datos del adro</h2>
        {image && <img src={image} alt="adro" className="request-modal-image" />}
        <div className="request-modal-data">
        <div className="columns-ad-info">
        {ad.tipo !== 'Varios' && (<div className="column-element-info">
            <p className="precio-info">Lote:</p>
            <p className="precio-info">{ad.lote}</p>
          </div>)}
          <div className="column-element-info">
            <p className="precio-info" spellcheck="false" translate="no">Precio:</p>
            <p className="precio-info" spellcheck="false" translate="no">
              Lps. {formatNumberWithCommas(ad.offerta ? ad.precioOferta : ad.precio)}
            </p>
          </div>
          <div className="column-element-info">
            <p className="title-element">Fecha de publicación:</p>
            <p className="date">{formatDate(ad.createdAt)}</p>
          </div>
          {ad.tipo !== 'Varios' ? (<div className="column-element-info">
            <p className="title-element">Marca:</p>
            <p className="content-element">{ad.marca}</p>
          </div>) : (
            <div className="column-element-info">
            <p className="title-element">Producto:</p>
            <p className="content-element">{ad.marca}</p>
          </div>
          )}
          <div className="column-element-info">
            <p className="title-element">Modelo:</p>
            <p className="content-element">{ad.modelo}</p>
          </div>
          <div className="column-element-info">
            <p className="title-element">Año:</p>
            <p className="content-element">{ad.anio}</p>
          </div>
          {ad.millaje !== 0 && (<div className="column-element-info">
            <p className="title-element">Millaje:</p>
            <p className="content-element">{ad.millaje}</p>
          </div>)}
          <div className="column-element-info">
            <p className="title-element">Condición:</p>
            <p className="content-element">{ad.condicion}</p>
          </div>
          <div className="column-element-info">
            <p className="title-element">Tipo:</p>
            <p className="content-element">{ad.tipo}</p>
          </div>
          <div className="column-element-info">
            <p className="title-element">Ubicación:</p>
            <p className="content-element">{ad.ubicacion}</p>
          </div>
          {ad.motor !== '0' && (<div className="column-element-info">
            <p className="title-element">Motor:</p>
            <p className="content-element">{ad.motor}</p>
          </div>)}
          {ad.combustible !== 'N/A' && (<div className="column-element-info">
            <p className="title-element">Combustible:</p>
            <p className="content-element">{ad.combustible}</p>
          </div>)}
          {ad.transmission !== 'N/A' && (<div className="column-element-info">
            <p className="title-element">Transmición:</p>
            <p className="content-element">{ad.transmission}</p>
          </div>)}
          {ad.traccion !== 'N/A' && (<div className="column-element-info">
            <p className="title-element">Tracción:</p>
            <p className="content-element">{ad.traccion}</p>
          </div>)}
          {ad.listado && (<div className="column-element-info">
            <p className="title-element">Listado:</p>
            <p className="content-element">{ad.listado}</p>
          </div>)}
          <div className="column-element-info">
            <p className="title-element">Camina:</p>
            <p className="content-element">{checkBoolean(ad.camina)}</p>
          </div>
          <div className="column-element-info">
            <p className="title-element">Enciende:</p>
            <p className="content-element">{checkBoolean(ad.enciende)}</p>
          </div>
          <div className="column-element-info">
            <p className="title-element">Grua incluída:</p>
            <p className="content-element">{checkBoolean(ad.gruaIncluida)}</p>
          </div>
          <div className="column-element-info">
            <p className="title-element">Gastos de introducción:</p>
            <p className="content-element">{checkBoolean(ad.Introduccion)}</p>
          </div>
          <div className="column-element-info">
            <p className="title-element">Gastos de inscripción:</p>
            <p className="content-element">
              {checkBoolean(ad.gastosDeInscripcion)}
            </p>
          </div>
          <div className="column-element-info">
            <p className="title-element">Costo de Placas:</p>
            <p className="content-element">{checkBoolean(ad.costosPlacas)}</p>
          </div>
          <div className="column-element-info">
            <p className="title-element">Costo de Vías Públicas:</p>
            <p className="content-element">{checkBoolean(ad.viasPublicas)}</p>
          </div>
          {ad.comentario !== "" && (<div className="column-element-info">
            <p className="title-element">Comentario:</p>
            <p className="content-element">{ad.comentario}</p>
          </div>)}
        </div>
        </div>
      </div>
    </div>
  );
};

export default adRequestModal;
